import { INITIALIZE_AUTH, UPDATE_GATES } from './constants/ActionTypes';
import { pricingPageDataFetchingClient } from '../v2/pricingPageDataFetchingClient';
import { GET_USER_INFO } from 'pricing-pages-api/user/queries';
// Fetch userInfo using the DFC query to enable storing the results in the instantiated
// instantiated pricingPageDataFetchingClient provider client for the V2 app,
// while maintaining existing Redux dispatching pattern
export const getAuth = () => dispatch => {
  return pricingPageDataFetchingClient.query({
    query: GET_USER_INFO
  }).then(userInfoQuery => {
    const payload = {
      user: userInfoQuery.data.userInfo.user,
      gates: userInfoQuery.data.userInfo.gates,
      portal: userInfoQuery.data.userInfo.portal
    };
    dispatch({
      type: INITIALIZE_AUTH,
      payload
    });
    return payload;
  });
};
export const updateGates = gates => ({
  type: UPDATE_GATES,
  payload: gates
});